import { render, staticRenderFns } from "./scientificResource.vue?vue&type=template&id=83f1ba6a&scoped=true&"
import script from "./scientificResource.vue?vue&type=script&lang=js&"
export * from "./scientificResource.vue?vue&type=script&lang=js&"
import style0 from "./scientificResource.vue?vue&type=style&index=0&id=83f1ba6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f1ba6a",
  null
  
)

export default component.exports